module.exports = __webpack_public_path__ + "static/media/ModulesTilesIcon.16ebec82.svg";